import {clearLearningRecovery} from '@/lib/academyLearningRecovery';
import { clearPendingClubLogin } from '@/utils/pendingClubLogin.js';
import { LAST_LOGOUT_CLUB_CODE_KEY, LAST_LOGOUT_RETURN_TO_KEY } from '@/utils/returnTo.js';

const AUTH0_CACHE_PREFIX = '@@auth0spajs@@';
const PRIVANA_KEY_PREFIXES = ['privana:', 'privana_'];
export const DINING_HOST_LOGOUT_CLUB_KEY = 'privana:dining-host:logout-club';
const PRESERVED_LOGOUT_KEYS = new Set([
  LAST_LOGOUT_RETURN_TO_KEY,
  LAST_LOGOUT_CLUB_CODE_KEY,
  DINING_HOST_LOGOUT_CLUB_KEY,
]);

export function rememberDiningHostLogoutClub(clubCode, storage = globalThis.window?.sessionStorage) {
  if (!storage) return null;
  const validatedClubCode = /^\d{6}$/.test(String(clubCode || '')) ? String(clubCode) : null;
  try {
    if (validatedClubCode) storage.setItem(DINING_HOST_LOGOUT_CLUB_KEY, validatedClubCode);
    else storage.removeItem(DINING_HOST_LOGOUT_CLUB_KEY);
  } catch (error) {
    console.warn('[logout] failed to persist Dining Host logout route', error);
  }
  return validatedClubCode;
}

export function consumeDiningHostLogoutDestination(
  origin,
  storage = globalThis.window?.sessionStorage,
) {
  const safeOrigin = String(origin || '').replace(/\/+$/, '');
  let storedClubCode = null;
  try {
    storedClubCode = storage?.getItem(DINING_HOST_LOGOUT_CLUB_KEY) || null;
    storage?.removeItem(DINING_HOST_LOGOUT_CLUB_KEY);
  } catch (error) {
    console.warn('[logout] failed to consume Dining Host logout route', error);
  }
  return /^\d{6}$/.test(String(storedClubCode || ''))
    ? `${safeOrigin}/${storedClubCode}`
    : safeOrigin;
}

export function startDiningHostLogout(logout, clubCode, origin = globalThis.window?.location?.origin) {
  rememberDiningHostLogoutClub(clubCode);
  return logout({
    logoutParams: {
      returnTo: `${String(origin || '').replace(/\/+$/, '')}/logout-complete`,
    },
  });
}

function clearMatchingStorage(storage) {
  if (!storage) return;

  try {
    const keys = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (!key || PRESERVED_LOGOUT_KEYS.has(key)) continue;
      if (
        key.startsWith(AUTH0_CACHE_PREFIX) ||
        PRIVANA_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))
      ) {
        keys.push(key);
      }
    }

    keys.forEach((key) => storage.removeItem(key));
  } catch (error) {
    console.warn('[logout] failed to clear local session storage', error);
  }
}

export function clearPrivanaLocalSessionState() {
  clearLearningRecovery();
  clearPendingClubLogin();

  if (typeof window === 'undefined') return;

  clearMatchingStorage(window.sessionStorage);
  clearMatchingStorage(window.localStorage);
}
